import {
  StatisticProps as AntdStatisticProps,
  Statistic as AntdStatistic,
} from "antd";
import React from "react";

const Statistic = (props: AntdStatisticProps) => {
  return <AntdStatistic {...props} />;
};

// TODO: After upgrade to >= 5.25.0, a
// Add Timer, remove deprecated Countdown
// Statistic.Timer = AntdStatistic.Timer;
/** @deprecated In v5.25.0, replaced with new Timer added in v5.25.0. */
Statistic.Countdown = AntdStatistic.Countdown;

export default Statistic;
